module.exports = __webpack_public_path__ + "img/b-play-wh.14f4c876.svg";